import { render, staticRenderFns } from "./ProposalRemoteSteps.vue?vue&type=template&id=761a243b"
import script from "./ProposalRemoteSteps.vue?vue&type=script&lang=js"
export * from "./ProposalRemoteSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports